import { render, staticRenderFns } from "./SalesPointList.vue?vue&type=template&id=79c0f8e2&"
import script from "./SalesPointList.vue?vue&type=script&lang=js&"
export * from "./SalesPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports